import React from 'react';
import {render} from 'react-dom';
import FerrySearchMask from './FerrySearchMask';
import createSearchMaskStore from './FerrySearchMask/FerrySearchMaskStore';

const searchMaskStore = createSearchMaskStore();

render((
  <FerrySearchMask store={searchMaskStore} />
), document.getElementById('ferrySearchMaskAffiliates'));
